import { getAtomicNumberString } from "../organizations";

/**
 * The three columns the atomic-number ordering actually reads. Kept structural so both the
 * PostgREST row shape (string dates) and a Drizzle row shape (Date objects) sort through the
 * same function — the dates never participate.
 */
export interface SortableServiceCalculationItem {
	id: string;
	parentServiceCalculationItemId: string | null;
	ranking: number;
}

/**
 * This function returns the atomic number of a service calculation item.
 * @param items
 * @param item
 * @returns
 */
export function getServiceCalculationItemAtomicNumber<T extends SortableServiceCalculationItem>(
	items: T[],
	item: T,
): string {
	const parent = items.find((i) => i.id === item.parentServiceCalculationItemId);
	if (!parent) return getAtomicNumberString(item.ranking.toString());
	return `${getServiceCalculationItemAtomicNumber(items, parent)}.${getAtomicNumberString(item.ranking.toString())}`;
}
